var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStriped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M268.67,35.726l-51.146-9.821V4.788c0-2.644-2.143-4.787-4.787-4.787H87.264c-2.645,0-4.787,2.144-4.787,4.787v21.118 L31.33,35.726c-10.783,2.071-19.557,12.688-19.557,23.667v219.862c0,11.438,9.307,20.744,20.744,20.744H267.48 c11.439,0,20.746-9.307,20.746-20.744V59.394C288.227,48.414,279.453,37.797,268.67,35.726z M278.65,279.256 c0,6.158-5.01,11.17-11.17,11.17H163.833h-9.046h-9.574h-6.752H32.518c-6.158,0-11.17-5.012-11.17-11.17V59.394 c0-6.505,5.398-13.038,11.787-14.266L85.57,35.06l31.943,34.188c1.006,1.077,2.453,1.629,3.92,1.5 c1.469-0.13,2.795-0.929,3.596-2.167l8.229-12.705l5.203-8.037l4.812-7.431c0.717-1.108,0.945-2.463,0.631-3.745 c-0.316-1.282-1.146-2.377-2.295-3.026l-28.877-16.302c-2.303-1.3-5.223-0.487-6.523,1.815c-1.299,2.303-0.486,5.223,1.816,6.522 l24.447,13.801l-4.621,7.136c-0.01,0.015-0.021,0.027-0.031,0.042s-0.018,0.03-0.025,0.045l-7.471,11.535l-28.273-30.26V9.575 h115.898v18.398l-28.275,30.26L172.18,46.66c-0.008-0.013-4.652-7.186-4.652-7.186l24.447-13.801 c2.303-1.3,3.115-4.22,1.816-6.522c-1.301-2.303-4.221-3.115-6.523-1.815l-28.877,16.302c-1.148,0.649-1.98,1.744-2.295,3.025 c-0.316,1.282-0.088,2.637,0.631,3.746l4.812,7.431l5.203,8.036l8.229,12.705c0.801,1.237,2.127,2.036,3.596,2.167 c0.141,0.013,0.281,0.019,0.422,0.019c1.32,0,2.588-0.546,3.498-1.519L214.43,35.06l52.436,10.068 c6.389,1.227,11.785,7.76,11.785,14.266V279.256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.936,74.255l0.607-0.563C191.324,73.864,191.121,74.049,190.936,74.255z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 95.051,
    y1: 63.995,
    x2: 31.348,
    y2: 127.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.516,60.459c-21.234,21.315-42.469,42.63-63.703,63.945c-4.555,4.572,2.516,11.644,7.07,7.071 c21.234-21.315,42.469-42.63,63.703-63.945C103.141,62.959,96.07,55.887,91.516,60.459L91.516,60.459z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 120.333,
    y1: 84,
    x2: 30.681,
    y2: 176.287
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.798,80.464c-29.885,30.763-59.769,61.525-89.652,92.288c-4.494,4.625,2.571,11.703,7.07,7.07 c29.885-30.762,59.769-61.524,89.652-92.287C128.362,82.91,121.297,75.833,116.798,80.464L116.798,80.464z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 170.252,
    y1: 75.485,
    x2: 31.681,
    y2: 223.644
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.717,71.949c-33.537,35.857-67.073,71.714-100.61,107.571c-12.653,13.529-25.308,27.059-37.961,40.588 c-4.399,4.703,2.657,11.789,7.07,7.07c33.537-35.856,67.073-71.714,100.61-107.57c12.653-13.529,25.308-27.059,37.961-40.588 C178.187,74.317,171.13,67.231,166.717,71.949L166.717,71.949z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 234.001,
    y1: 50.667,
    x2: 34.333,
    y2: 273.639
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M230.466,47.131c-27.853,31.103-55.704,62.206-83.557,93.309c-36.499,40.758-72.998,81.517-109.497,122.276 c-2.205,2.463-4.41,4.925-6.614,7.388c-4.288,4.787,2.761,11.884,7.07,7.07c27.853-31.103,55.704-62.205,83.557-93.308 c36.499-40.759,72.998-81.518,109.497-122.277c2.205-2.462,4.41-4.924,6.614-7.387 C241.824,49.415,234.775,42.318,230.466,47.131L230.466,47.131z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 265.19,
    y1: 108.468,
    x2: 122.746,
    y2: 275.639
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M261.655,104.932c-31.182,36.594-62.363,73.188-93.544,109.782c-16.301,19.13-32.601,38.26-48.9,57.39 c-4.157,4.878,2.882,11.986,7.07,7.07c31.182-36.594,62.363-73.188,93.544-109.781c16.301-19.13,32.601-38.26,48.9-57.389 C272.883,107.125,265.844,100.017,261.655,104.932L261.655,104.932z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 265.19,
    y1: 162.127,
    x2: 168.469,
    y2: 275.639
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M261.655,158.592c-31.21,36.627-62.42,73.254-93.629,109.882c-1.031,1.21-2.062,2.42-3.093,3.63 c-4.157,4.878,2.882,11.986,7.07,7.07c31.21-36.627,62.42-73.254,93.629-109.882c1.031-1.21,2.062-2.42,3.093-3.63 C272.883,160.784,265.844,153.676,261.655,158.592L261.655,158.592z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 267.19,
    y1: 211.71,
    x2: 212.719,
    y2: 275.639
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M263.655,208.175c-18.157,21.31-36.314,42.619-54.472,63.929c-4.157,4.878,2.882,11.986,7.07,7.07 c18.157-21.31,36.314-42.619,54.472-63.929C274.883,210.367,267.844,203.259,263.655,208.175L263.655,208.175z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("line", {
    id: "SVGID_1_",
    x1: 262.918,
    y1: 65.995,
    x2: 76.507,
    y2: 275.639
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M77,65.996v209.645V65.996z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#FEFEFE",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#FDFDFD",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#FCFCFC",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#FBFBFB",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#FAFAFA",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#F9F9F9",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#F8F8F8",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#F7F7F7",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#F7F6F6",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#F6F5F5",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#F5F4F4",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#F4F3F3",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#F3F2F2",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#F2F1F1",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#F1F0F0",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#F0EFEF",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#EFEEEE",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#EEEDED",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#EDECEC",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#ECEBEB",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#EBEAEA",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#EAE9E9",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#E9E8E8",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#E8E7E7",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#E7E6E6",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#E6E5E5",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#E6E4E4",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#E5E3E3",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#E4E2E2",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#E3E1E1",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#E2E0E0",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#E1DFDF",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#E0DEDE",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#DFDDDD",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#DEDCDC",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#DDDBDB",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#DCDADA",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#DBD9D9",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#DAD8D8",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#D9D7D7",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#D8D6D6",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#D7D5D5",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#D6D4D4",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#D5D3D3",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#D5D2D2",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#D4D1D1",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#D3D0D0",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#D2CFCF",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#D1CECE",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#D0CDCD",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#CFCCCC",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#CECBCB",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#CDCACA",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#CCC9C9",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#CBC8C8",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#CAC7C7",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#C9C6C6",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#C8C5C5",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#C7C5C4",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#C6C4C3",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#C5C3C2",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#C4C2C1",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#C4C1C0",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#C3C0BF",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#C2BFBE",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#C1BEBD",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#C0BDBC",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#BFBCBB",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#BEBBBA",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#BDBAB9",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#BCB9B8",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#BBB8B7",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#BAB7B6",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#B9B6B5",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#B8B5B4",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#B7B4B3",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#B6B3B2",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#B5B2B1",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#B4B1B0",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#B3B0AF",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#B3AFAE",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#B2AEAD",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#B1ADAC",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#B0ACAB",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#AFABAA",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#AEAAA9",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#ADA9A8",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#ACA8A7",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#ABA7A6",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#AAA6A5",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#A9A5A4",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#A8A4A3",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#A7A3A2",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#A6A2A1",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#A5A1A0",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#A4A09F",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#A39F9E",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#A29E9D",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#A29D9C",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#A19C9B",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#A09B9A",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#9F9A99",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#9E9998",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#9D9897",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#9C9796",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#9B9695",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#9A9594",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#999493",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#989392",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#979291",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#969190",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#95908F",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#948F8E",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#938E8D",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#928D8C",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#918C8B",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#918B89",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#908A88",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#8F8987",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#8E8886",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#8D8785",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#8C8684",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#8B8583",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#8A8482",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#898381",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#888280",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#87817F",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#86807E",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#857F7D",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#847E7C",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#837D7B",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#827C7A",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#817B79",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#807A78",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#807977",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#7F7876",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#7E7775",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#7D7674",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#7C7573",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#7B7472",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#7A7371",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#797270",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#78716F",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#77706E",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#766F6D",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#756E6C",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#746D6B",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#736C6A",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#726B69",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#716A68",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#706967",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#6F6866",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#6F6765",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#6E6664",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#6D6563",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#6C6462",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#6B6361",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#6A6260",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#69615F",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#68605E",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#675F5D",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#665E5C",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#655D5B",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#645C5A",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#635B59",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#625A58",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#615957",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#605856",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#5F5755",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#5E5654",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#5E5553",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#5D5452",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#5C5351",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#5B5250",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#5A524F",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#59514E",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#58504D",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#574F4C",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#564E4B",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#554D4A",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#544C49",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#534B48",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#524A47",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#514946",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#504845",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#4F4744",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#4E4643",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#4D4542",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#4D4441",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#4C4340",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#4B423F",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#4A413E",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#49403D",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#483F3C",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#473E3B",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#463D3A",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#453C39",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#443B38",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#433A37",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#423936",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#413835",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#403734",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#3F3633",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#3E3532",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#3D3431",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#3C3330",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#3C322F",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#3B312E",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#3A302D",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#392F2C",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#382E2B",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#372D2A",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#362C29",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#352B28",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#342A27",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#332926",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#322825",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#312724",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#302623",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#2F2522",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#2E2421",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#2D2320",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#2C221F",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B211E",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#2B201D",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#2A1F1C",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#291E1B",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#281D1A",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#271C19",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#261B18",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#251A17",
    width: 0,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#241916",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 66,
    clipPath: "url(#SVGID_2_)",
    fill: "#231815",
    width: 1,
    height: 210
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231815",
    d: "M263,275.641V65.996V275.641z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M259.383,62.459c-28.746,32.329-57.492,64.657-86.238,96.986c-32.942,37.048-65.885,74.097-98.828,111.145 c-0.448,0.505-0.896,1.009-1.345,1.514c-4.27,4.801,2.777,11.899,7.07,7.07c28.746-32.328,57.492-64.656,86.238-96.985 c32.942-37.048,65.886-74.097,98.828-111.145c0.448-0.504,0.896-1.008,1.345-1.513 C270.723,64.729,263.676,57.631,259.383,62.459L259.383,62.459z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStriped);
export default __webpack_public_path__ + "static/media/striped.bf6a40b12a77b7bf557641a06c385469.svg";
export { ForwardRef as ReactComponent };